import {
  GETCUSTOMERDETAILS_SUCCESS,
  GETCUSTOMERDETAILS_FAILED,
  RESET_GETCUSTOMERDETAILS,
  LOADING_GETCUSTOMERDETAILS,
  NETWORK_ERROR_GETCUSTOMERDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCustomerDetails = () => {
  return { type: RESET_GETCUSTOMERDETAILS };
};

const getCustomerDetails = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETCUSTOMERDETAILS });
  await partnerServices
    .post("getCustomerDetails", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getCustomerDetailssuccess(res.data));
          break;
        default:
          dispatch(getCustomerDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETCUSTOMERDETAILS, payload: err });
    });
};
function getCustomerDetailssuccess(data) {
  return {
    type: GETCUSTOMERDETAILS_SUCCESS,
    payload: data,
  };
}
function getCustomerDetailsFailed(data) {
  return {
    type: GETCUSTOMERDETAILS_FAILED,
    payload: data,
  };
}

export { resetGetCustomerDetails, getCustomerDetails };
